import { Flex, Text } from '@chakra-ui/react';
import { faRefresh } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@morressier/alembic';
import dateFormat from 'dateformat';
import { IChangeRequestData } from '@publishing-engine/domain/models';
import Divider from 'src/components/Divider';

interface Props {
  onClose: VoidFunction;
  changeRequestHistory: IChangeRequestData[];
}

export const ChangeRequestModal = ({
  onClose,
  changeRequestHistory
}: Props) => {
  return (
    <Modal
      isOpen
      onClose={onClose}
      width="720px"
      closeButtonProps={{
        hidden: true
      }}
      data-cy="change-request-log-modal"
    >
      <Flex padding={8} gap={6} flexDirection="column">
        <Flex alignItems="flex-start" flexDirection="column">
          <FontAwesomeIcon fontSize={32} icon={faRefresh} />
        </Flex>

        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingGroup">Change Request Log</Text>
        </Flex>

        {changeRequestHistory?.map((history, index) => {
          return (
            <Flex
              flexDirection="column"
              gap={4}
              key={`${index}-${history.date}`}
            >
              <Text textStyle="headingOverline">
                {dateFormat(history.date, 'mmmm d, yyyy')}
              </Text>

              <Flex flexDirection="column" gap={2}>
                <Text textStyle="headingItem">Response to Author</Text>
                <Text>{history.reason}</Text>
              </Flex>

              <Flex flexDirection="column" gap={2}>
                <Text textStyle="headingItem">Changes Requested</Text>
                <ul>
                  {history.fields.map(field => (
                    <li>{field}</li>
                  ))}
                </ul>
              </Flex>

              {changeRequestHistory.length - 1 !== index && Divider}
            </Flex>
          );
        })}

        <Flex gap={2} justifyContent="flex-end">
          <Button
            type="submit"
            variant="primary"
            onClick={onClose}
            data-cy="change-request-log-modal-close-button"
          >
            Close
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
